export const ADD_ESTUDIANTE_DATA = 'ADD_ESTUDIANTE_DATA';

const estudianteReducer = (state = {}, action: any) => {
	switch (action.type) {
		case ADD_ESTUDIANTE_DATA: {
			return {
				...state,
				user: action.payload
			};
		}

		default:
			return state;
	}
};

export default estudianteReducer;
